module.exports = __webpack_public_path__ + "static/media/xls.2b5f49f1.svg";